module.exports = __webpack_public_path__ + "assets/70268c67a3516ee96c6b852888de9a71.svg";